export const ACCOUNTING_WIDGET_TYPE = "zeipt_accounting";

export const GLOBAL_WIDGET_TYPES = [
  ACCOUNTING_WIDGET_TYPE,
  "zeipt_second_hand",
  "zeipt_insurance_claims",
] as const;

export type GlobalWidgetType = (typeof GLOBAL_WIDGET_TYPES)[number];

export const QUICK_SEND_ACCOUNTING_POPUP_TYPE = "zeipt_accounting_quick_send";

export type PopupArticle = { art_number?: string; art_final_price?: number };

export interface PopupState {
  type: string;
  index: number;
  article?: PopupArticle;
}

export const CLOSED_POPUP_STATE: Readonly<PopupState> = {
  type: "",
  index: -1,
};

export const isGlobalWidgetType = (
  type: string
): type is GlobalWidgetType =>
  (GLOBAL_WIDGET_TYPES as readonly string[]).includes(type);
